const i18nService = {
  defaultLanguage: "fa",

  languages: [
    {
      lang: "en_US",
      name: "English (US)",
      flag: "/media/flag/us.svg",
    },
    {
      lang: "en_GB",
      name: "English (UK)",
      flag: "/media/flag/gb.svg",
    },
    {
      lang: "fa",
      name: "فارسی",
      flag: "/media/flag/ir.svg",
    },
    {
      lang: "ar",
      name: "العربية",
      flag: "/media/flag/sa.svg",
    },
    {
      lang: "ar_ae",
      name: "العربية (الإمارات)",
      flag: "/media/flag/ae.svg",
    },
    {
      lang: "ar_iq",
      name: "العربية (العراق)",
      flag: "/media/flag/iq.svg",
    },
    {
      lang: "de",
      name: "Deutsch",
      flag: "/media/flag/de.svg",
    },
    {
      lang: "fr",
      name: "Français",
      flag: "/media/flag/fr.svg",
    },
    {
      lang: "hy",
      name: "Հայերեն",
      flag: "/media/flag/am.svg",
    },
    {
      lang: "ru",
      name: "Русский",
      flag: "/media/flag/ru.svg",
    },
    {
      lang: "tr",
      name: "Türkçe",
      flag: "/media/flag/tr.svg",
    },
    {
      lang: "zh_CN",
      name: "简体中文",
      flag: "/media/flag/cn.svg",
    },
    {
      lang: "zh_TW",
      name: "繁體中文",
      flag: "/media/flag/tw.svg",
    },
  ],
};

export default i18nService;
